import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-64dd4bba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date ", -1))
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = {
  class: "card",
  style: {"padding":"0px !important"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, "magasins")
], -1))
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table w-100" }
const _hoisted_14 = { style: {"width":"100% !important"} }
const _hoisted_15 = { style: {"margin-bottom":"5px !important","width":"100% !important"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = {
  class: "card",
  style: {"padding":"0px !important"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, "produit conditionnement")
], -1))
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "table" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Produit"),
    /*#__PURE__*/_createElementVNode("th", null, "Qte Logique"),
    /*#__PURE__*/_createElementVNode("th", null, "Qte Physique"),
    /*#__PURE__*/_createElementVNode("th", null, "Ecart"),
    /*#__PURE__*/_createElementVNode("th", null, "Observation"),
    /*#__PURE__*/_createElementVNode("th", null, "Regu?"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_24 = { style: {"margin-bottom":"5px !important","min-width":"300px !important"} }
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_27 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "card-footer" }
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Enregistrer ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "elementForm",
        onSubmit: _ctx.addElement,
        "validation-schema": _ctx.elementSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_Field, {
                    name: "dateInventaire",
                    type: "date",
                    value: _ctx.getCurrentDate(),
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, null, 8, ["value"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateInventaire",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("tbody", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approMags, (mg, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_15, [
                                _createVNode(_component_Field, {
                                  name: 'mg_'+index,
                                  modelValue: mg.magasin,
                                  "onUpdate:modelValue": ($event: any) => ((mg.magasin) = $event),
                                  style: {"min-width":"100px !important"}
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_Multiselect, _mergeProps({
                                      modelValue: field.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                      ref_for: true
                                    }, field, {
                                      options: _ctx.getFilteredOptions(index),
                                      searchable: true,
                                      placeholder: "Rechercher un magasin",
                                      noResultText: "Aucun enregistrement trouvé",
                                      noOptionsText: "Tapez au moins deux caractères"
                                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                                  ]),
                                  _: 2
                                }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: 'mg_'+index,
                                  class: "text-danger"
                                }, null, 8, ["name"]),
                                _hoisted_16,
                                _createTextVNode(),
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _hoisted_20,
                                    _createElementVNode("div", _hoisted_21, [
                                      _createElementVNode("table", _hoisted_22, [
                                        _hoisted_23,
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitCondInventaires, (pro, pIndex) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: pIndex }, [
                                              _createElementVNode("td", _hoisted_24, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_pro'+pIndex,
                                                  modelValue: pro.produitConditionnement,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.produitConditionnement) = $event),
                                                  style: {"min-width":"100px !important"}
                                                }, {
                                                  default: _withCtx(({ field }) => [
                                                    _createVNode(_component_Multiselect, _mergeProps({
                                                      modelValue: field.value,
                                                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                                      ref_for: true
                                                    }, field, {
                                                      options: _ctx.getFilteredOptionsPC(index,pIndex),
                                                      searchable: true,
                                                      placeholder: "Rechercher un produit",
                                                      noResultText: "Aucun enregistrement trouvé",
                                                      noOptionsText: "Tapez au moins deux caractères"
                                                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                                                (_ctx.valideteRowElement(pro.produitConditionnement))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_qteLog'+pIndex,
                                                  type: "text",
                                                  modelValue: pro.qteLog,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.qteLog) = $event),
                                                  readonly: "true",
                                                  class: "form-control shadow-none fs-md-15 text-black",
                                                  placeholder: "0"
                                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                                (_ctx.valideteRowElement(pro.qteLog))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, " La quantité logiciel est obligatoire "))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_qtePhy'+pIndex,
                                                  type: "text",
                                                  modelValue: pro.qtePhy,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.qtePhy) = $event),
                                                  class: "form-control shadow-none fs-md-15 text-black",
                                                  placeholder: "0"
                                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                                (_ctx.valideteRowElement(pro.qtePhy))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, " La quantité physique est obligatoire "))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_ecart'+pIndex,
                                                  type: "text",
                                                  modelValue: pro.ecart,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.ecart) = $event),
                                                  class: "form-control shadow-none fs-md-15 text-black",
                                                  placeholder: "0",
                                                  readonly: "true"
                                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_component_ErrorMessage, {
                                                  name: 'pro_ecart'+pIndex,
                                                  class: "text-danger"
                                                }, null, 8, ["name"])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_observation'+pIndex,
                                                  type: "text",
                                                  modelValue: pro.observation,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.observation) = $event),
                                                  class: "form-control shadow-none fs-md-15 text-black",
                                                  placeholder: ""
                                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_component_ErrorMessage, {
                                                  name: 'pro_observation'+pIndex,
                                                  class: "text-danger"
                                                }, null, 8, ["name"])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_estRegularise'+pIndex,
                                                  type: "checkbox",
                                                  modelValue: pro.estRegularise,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.estRegularise) = $event),
                                                  value: true,
                                                  "unchecked-value": false,
                                                  class: "form-check-input shadow-none"
                                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_component_ErrorMessage, {
                                                  name: 'pro_estRegularise'+pIndex,
                                                  class: "text-danger"
                                                }, null, 8, ["name"])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn btn-sm btn-outline-danger",
                                                  onClick: ($event: any) => (_ctx.removeLigne(pIndex))
                                                }, " x ", 8, _hoisted_28)
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16", { 'cursor-not-allowed': _ctx.isDisable }]),
                                        disabled: _ctx.isDisable,
                                        onClick: ($event: any) => (_ctx.AddProduitCondInventaire(index))
                                      }, " + produit conditionnement ", 10, _hoisted_30)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_31,
              _hoisted_32
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_router_link, {
                  to: "/inventaires",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_37,
                    _hoisted_38,
                    _createTextVNode("Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}